import { render } from "./HomeENG.vue?vue&type=template&id=0ba94fd0&scoped=true"
import script from "./HomeENG.vue?vue&type=script&lang=js"
export * from "./HomeENG.vue?vue&type=script&lang=js"

import "./HomeENG.vue?vue&type=style&index=0&id=0ba94fd0&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba94fd0"]])

export default __exports__